import React from 'react';
import classnames from 'classnames';
import { object, array, node, string, bool } from 'prop-types';
import { CarouselLink } from '../CarouselLink';
import { TitleSection } from './TitleSection';

import './style.scss';

export const CarouselHeader = ({
    className,
    titleClassName,
    titleSections,
    subtitles,
    showMore,
    dataEnrichment,
    children = null,
    withHeaderText = true,
    showMoreClassName,
    metadata,
}) => {
    if (!titleSections) {
        return null;
    }

    return (
        <header
            className={classnames(`carousel-header ${!withHeaderText && 'carousel-header-without-text'}`, className)}
        >
            {withHeaderText && (
                <div className="titles">
                    <div className="title">
                        <TitleSection
                            className={titleClassName}
                            textSections={titleSections}
                            dataEnrichment={dataEnrichment}
                            isTitle
                            serviceId={metadata?.service_id}
                        />
                    </div>
                    {subtitles && (
                        <div className="subtitle">
                            <TitleSection textSections={subtitles} isSubtitle />
                        </div>
                    )}
                </div>
            )}
            {showMore && (
                <CarouselLink
                    className={showMoreClassName}
                    urlData={showMore}
                    dataEnrichment={dataEnrichment}
                    showMore
                />
            )}
            {children}
        </header>
    );
};

CarouselHeader.propTypes = {
    className: string,
    titleClassName: string,
    titleSections: array,
    subtitles: array,
    dataEnrichment: object,
    showMore: object,
    children: node,
    withHeaderText: bool,
    showMoreClassName: string,
    metadata: object,
};
